export enum EWorkspaces {
  TIMELINE = 'timeline',
  OVERVIEW = 'overview',
  REMINDERS = 'reminders',
}
